<mat-sidenav-container class="example-container">
  <mat-sidenav #sidenav mode="over" [fixedInViewport]="true" class="rounded-r-xl">
    <div class="w-[434px] flex flex-col h-full">

      <ng-content select="[sideMenuHeader]"></ng-content>

      <div class="flex flex-col pl-24 pr-16 h-full justify-between">
        <div class="mt-5">
          @for (item of menuItems; track item.title) {
            <app-menu-item [iconName]="item.iconName"
                           class="text-blue min-h-[50px] px-3 pr-8 cursor-pointer items-center"
                           (click)="onItemClick(item)">
              {{ item.title }}
              @if (item.count?.()) {
                <app-badge class="bg-gray">{{ item.count?.() }}</app-badge>
              }
            </app-menu-item>
          }
        </div>

        <div class="mt-4">
          <img class="mb-6" src="assets/img/logo.png" alt="logo"/>
          <div class="flex gap-3">
            <app-icon class="text-gray" name="instagram"></app-icon>
            <app-icon class="text-gray" name="twitter"></app-icon>
            <app-icon class="text-gray" name="facebook"></app-icon>
          </div>
          <div class="my-9 text-gray-300">
            ©{{ today | date:'yyyy' }} My History. All rights reserved.
          </div>
        </div>
      </div>

    </div>
  </mat-sidenav>
  <mat-sidenav-content>

    <ng-content></ng-content>

  </mat-sidenav-content>
</mat-sidenav-container>
